module.exports = __webpack_public_path__ + "img/career-certification.8eb6e7f2.png";